import { render } from "./StoryChangeUser.vue?vue&type=template&id=1892911c&scoped=true"
import script from "./StoryChangeUser.vue?vue&type=script&lang=js"
export * from "./StoryChangeUser.vue?vue&type=script&lang=js"

import "./StoryChangeUser.vue?vue&type=style&index=0&id=1892911c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1892911c"]])

export default __exports__